const WORKERS_URL = String(
  import.meta.env.VITE_API_WORKERS_URL || "https://dash.api-atomicpay.com"
).replace(/\/$/, "");

/** Resolve checkout image srcs, including relative library asset paths. */
export function mediaUrl(url) {
  if (!url) return "";
  let resolved = String(url);
  if (!/^https?:\/\//i.test(resolved)) {
    resolved = `${WORKERS_URL}${resolved.startsWith("/") ? "" : "/"}${resolved}`;
  }
  const oldUrl = import.meta.env.VITE_MEDIA_OLD_URL;
  const nextUrl = import.meta.env.VITE_MEDIA_URL;
  if (oldUrl && nextUrl) {
    return resolved.replace(oldUrl, nextUrl);
  }
  return resolved;
}
